import { lazyLoad } from './lazyload-init.js';

var floorPlansMainCarousel;
var floorPlanModalCarousel;
var contentType = 'floor-plans';

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Add labels to slider with values based on price range values
function rangeSliderLabels($priceSlider, priceRangeValues) {

    $priceSlider.find('label').remove();

    // Get the options for this slider (specified above)
    var opt = $priceSlider.data().uiSlider.options;
    // Get the number of possible values
    var vals = opt.max - opt.min;

    // Position the labels
    for (var i = 0; i <= vals; i++) {
        var labelTxt = '';
        // Set price for first & last label
        if(i == 0 || i == vals) {
            var labelTxt = priceRangeValues[i + opt.min].toLocaleString();
        }
        
        // Create a new element and position it with percentages
        var el = $('<label>' + (labelTxt) + '</label>').css('left', (i/vals*100) + '%');
        // Add the element inside #slider
        $priceSlider.append(el);

    }
}

// Floor Plans Carousel
function floorPlansCarousel(carouselElem, carousel) {

    // Set the carousel options
    var floorPlansOptions = {
        items: 1,
        onInitialized: function(elem){
            setTimeout(() => {
                $(elem.currentTarget).addClass('init-done');
            }, 180);
            
        }
    }

    if ( carousel == 'main' ) {
        floorPlansMainCarousel = carouselElem.owlCarousel(floorPlansOptions);
        // Nav active change
        floorPlansMainCarousel.on('changed.owl.carousel', function(event) {
            var activeIndex = event.item.index;
            $('#apt-content-overlay-placeholder .floor-plans-nav .btn-carousel-js[data-item="'+activeIndex+'"]').addClass('active').siblings().removeClass('active');
        })

    } else if ( carousel == 'modal' ) {
        floorPlanModalCarousel = carouselElem.owlCarousel(floorPlansOptions);
        // Nav active change
        floorPlanModalCarousel.on('changed.owl.carousel', function(event) {
            var activeIndex = event.item.index;
            $('#floor-plans-modal .floor-plans-nav .btn-carousel-js[data-item="'+activeIndex+'"]').addClass('active').siblings().removeClass('active');
        })
    }
}

// Document ready
$(function(){
    
    var $aptContainer = $('#apartment-container');
    var $aptListContainer = $('#apartments-accordion');
    var $apContentContainer = $('#apt-content-container');
    var $aptContentToggle = $aptContainer.find('#content-toggle');
    var floorPlansModal = $('#floor-plans-modal');
    var $apFormFilter = $aptContainer.find('#apartments-filter-form');

    if( $aptContainer.length ) {
        var $aptButtons = $aptListContainer.find('.apartment-show-js');
        var $aptHeaderContainer = $aptContainer.find('#map-header .apt-meta-holder');
        var $aptOverlayContentContainer = $aptContainer.find('#apt-content-overlay-placeholder');
        let lazyLoadInstance  = lazyLoad(); // Add lazyLoad
        
        // init Modal
        floorPlansModal.modal();
        // Modal listeners
        floorPlansModal.on('show.bs.modal', function (e) {
            var modalFloorPlansImages = $(this).find('.floor-plan-images');

            if( modalFloorPlansImages.hasClass('owl-carousel') ) {
                floorPlansCarousel(modalFloorPlansImages, 'modal');
            }
        })
        

        // Unit Click
        $aptButtons.on('click', function() {
            var $activeBtn = $(this);
            var $btnBgColor = $activeBtn.data('bg-color');
            var aptDataID = $activeBtn.data('apt-id');
            var $aptContent = '';
            var $aptContentActive = '';
            var $aptContentHeader = '';
            var $aptContentOverlay = '';

            // Clone content to content area
            if ( aptDataID) {
                $aptContent = $apContentContainer.find('.apt-item[data-apt-id='+aptDataID+']');
                $aptContentActive = $aptContent.addClass('active');
                $aptContentHeader = $aptContent.find('.apt-header-data').clone();
                $aptContentOverlay = $aptContent.find('.apt-overlay-content').clone();

                // Clone content to main area
                $aptHeaderContainer.html($aptContentHeader);
                $aptOverlayContentContainer.html($aptContentOverlay);
                lazyLoadInstance.update(); // Update LazyLoad

                // Carousel
                var $floorPlansImages = $aptOverlayContentContainer.find('.floor-plan-images');
                var $floorPlansNav = $aptOverlayContentContainer.find('.floor-plans-nav');
                var floorPlansHasCarousel = $floorPlansImages.hasClass('owl-carousel');

                // Init Main carousel
                if( floorPlansHasCarousel ) {
                    floorPlansCarousel($floorPlansImages, 'main');
                    $floorPlansNav.find('.btn-carousel-js').first().addClass('active');
                }

                // Main Carousel Nav click
                $floorPlansNav.find('.btn-carousel-js').on('click', function(){
                    var floorPlanNavID = $(this).data('item');

                    // If AXO then change to Floor Plans
                    if ( contentType == 'axo' ) {
                        $aptOverlayContentContainer.find('.content-toggle-js[data-type="floor-plans"]').trigger('click');
                    }
                    //$(this).addClass('active').siblings().removeClass('active');
                    floorPlansMainCarousel.trigger('to.owl.carousel', [floorPlanNavID, 300]);
                });

                $aptOverlayContentContainer.find('.image-zoom-js').on('click', function(){
                    var modalContent = '';
                    var modalCarousel = $aptContent.find('.apt-overlay-content .floor-plan-images ').clone();
                    var modalCarouselNav = ( $aptContent.find('.apt-overlay-content .footer-actions .floor-plans-nav').length ) ? $aptContent.find('.apt-overlay-content .footer-actions .floor-plans-nav').clone() : '';

                    floorPlansModal.find('.modal-body').html(modalCarousel);
                    lazyLoadInstance.update(); // Update LazyLoad
                    floorPlansModal.find('.modal-footer').html(modalCarouselNav);
                    floorPlansModal.modal('show');
                    
                    // if( floorPlansHasCarousel ) {
                    //     var floorPlanImg = $floorPlansImages.find('.item.active img').attr('src');
                    // } else {
                    //     var floorPlanImg = $floorPlansImages.find('.item img').attr('src');
                    // }
                    
                    // // Set image and trigger Modal
                    // if( floorPlanImg ) {

                    // }
                });
    
            }

            // var mapImg = $activeBtn.data('map-img');
            // var $mapContainer = $ulNbhMapsContainer.find('.map-container');
            // var $mapContainerInner = $mapContainer.find('.map-wrapper');

            // Remove active state, else show map
            if( $activeBtn.hasClass('active') ) {
                //$devButtons.removeClass('active');
                //$mapContainer.removeClass('is-visible');
            } else {
                $aptButtons.removeClass('active'); // Remove all active classes
                $aptButtons.css({ "background-color" : "inherit" }); // Remove all active classes
                $activeBtn.addClass('active');
                $activeBtn.css({ "background-color" : $btnBgColor });
                // $mapContainer.addClass('is-visible');
                // $mapContainerInner.html('<img src="'+mapImg+'" class="map-img img-fuild w-100">');
            }

        });

        /* Content Toggle */
        $aptOverlayContentContainer.on('click', '.content-toggle-js',function(e){
            var $button = $(this);
            contentType = $button.data('type');

            $button.addClass('active').siblings('button').removeClass('active');

            
            switch (contentType) {
                case 'floor-plans':                    
                    $aptOverlayContentContainer.find('.axo-container').hide();
                    $aptOverlayContentContainer.find('.floor-plans-container').show();
                    break;

                case 'axo':
                    $aptOverlayContentContainer.find('.floor-plans-container').hide();
                    $aptOverlayContentContainer.find('.axo-container').show();
                    break;
            }
        });

        /* Modal carousel - Nav */
        floorPlansModal.on('click', '.btn-carousel-js',function(e){
            var floorPlanNavID = $(this).data('item');
            floorPlanModalCarousel.trigger('to.owl.carousel', [floorPlanNavID, 300]);
        });
        

        // Apartment form filter
        if ( $apFormFilter.length ) {

            // Apartments filter Sales Status
            $('#filter-sales-status select').on('change', function() {
                var filterValue = $(this).val();

                //$aptListContainer.find('.development-grid-item[data-unit-status="'+filterValue+'"]').addClass('yes');

                switch (filterValue) {
                    case 'price':
                        // Hide all with no values
                        $aptListContainer.find('.development-grid-item[data-price=""]').each(function(e){
                            $(this).addClass('is-hidden').hide();

                        }).promise().done( function(){ 
                            // Show price range filter
                            $apFormFilter.find('.form-price-range-filter').show();
                            // Hide all types that have no visible units
                            $aptListContainer.find('.accordion-item').each(function(e){
                                $(this).addClass('dev-check');
                                var visibleUnits = $(this).find('.units-wrapper .development-grid-item:not(.is-hidden)').length;
                                if ( visibleUnits == 0) {
                                    $(this).addClass('is-hidden').hide();
                                }
                            });
                        });
                        
                        break;
                
                    default:
                        // Hide price range filter
                        $apFormFilter.find('.form-price-range-filter').hide();
                        var priceMinFormatted = priceRangeValues[0].toLocaleString();
                        var priceMaxFormatted = priceRangeValues[priceRangeValues.length - 1].toLocaleString();
                        $priceSlider.slider('values', 0, 0); // reset sets min handle
                        $priceSlider.slider('values', 1, priceRangeValues.length - 1); // reset set max handle
                        $priceValues.find('#price-range-min').val(priceMinFormatted); // set min handle value
                        $priceValues.find('#price-range-max').val(priceMaxFormatted); // set max handle value
                        // Show all unit types
                        $aptListContainer.find('.accordion-item.is-hidden').each(function(){
                            $(this).removeClass('is-hidden').show();
                        });
                        // Show all units
                        $aptListContainer.find('.development-grid-item.is-hidden').each(function(){
                            $(this).removeClass('is-hidden').show();
                        });
                        break;
                }

                /* if( filterValue == 'default' ) {

                    $aptListContainer.find('.accordion-item .units-wrapper').each(function(){
                        var $unitTypeAcc = $(this);

                        $unitTypeAcc.find('.development-grid-item')
                        .sort((a,b) => $(a).data("sort-default") - $(b).data("sort-default"))
                        .appendTo($unitTypeAcc);
                    });

                    // $aptListContainer.find('.development-grid-item')
                    //     .sort((a,b) => $(a).data("sort-default") - $(b).data("sort-default"))
                    //     .appendTo($(this).closest('.units-wrapper'));

                } else {
                    $aptListContainer.find('.development-grid-item[data-unit-status!="'+filterValue+'"]').each(function(){
                        var parentContainer = $(this).closest('.units-wrapper');
                        parentContainer.addClass('unit-sroted');
                        $(this).appendTo(parentContainer);
                    });
                } */
            });

            // Unit filter
            $('.form-checkboxes input').on('change',function() {                
                var filtertype = $(this).data('filter');
                var checkboxCount = 0;
                var checkboxInactiveCount = 0;

                $apFormFilter.find('input[data-filter="'+filtertype+'"]').each(function(e){
                    var filterValue = $(this).val();
                    if($(this).prop("checked") == true){                    
                        $aptListContainer.find('.accordion-item[data-'+filtertype+'="'+filterValue+'"]').show();
                    } else {
                        checkboxInactiveCount = checkboxInactiveCount+1;
                        $aptListContainer.find('.accordion-item[data-'+filtertype+'="'+filterValue+'"]').hide();
                    }
                    checkboxCount = checkboxCount+1;
                });

                if( checkboxCount == checkboxInactiveCount ) {
                    $aptListContainer.find('.accordion-item').show();
                }               
            });
        }

        // Preselect Apartment if in URL
        if( getUrlParameter('apt') ) {
            var apartmentID = getUrlParameter('apt');

            var $activeApartment = $aptListContainer.find('.development-grid-item button[data-apt-id="'+apartmentID+'"]');
            
            if($activeApartment) {                
                setTimeout(() => {
                    $activeApartment.closest('.accordion-item').find('.accordion-button').trigger('click');

                    setTimeout(() => {
                        $activeApartment.trigger('click');
                    }, 400);
                }, 400);
                
            }
        }
    }

    // Price range slider
    // Ref: different step size 
    // https://stackoverflow.com/questions/967372/jquery-slider-how-to-make-step-size-change
    var $priceSlider = $( "#price-range-slider[data-type='filter']" );
    
    if ( $priceSlider.length ) {
        var $priceValues = $('.price-range-values[data-type="filter"]');
        var priceRangeValues = [];
        // Budgets
        var priceValues = [1000000, 3500000, 6000000, 8500000, 10000000, 12500000, 15000000];

        // Set the default price range
        priceRangeValues = priceValues;
        
        // Init slider & set Price bond as default
        $priceSlider.slider({
            range: true,
            min: 0,
            max: priceRangeValues.length - 1,
            values: [ 0, priceRangeValues.length - 1],
            //step: 2500000,
            // On create
            create: function( event, ui ) {
                var priceMin =  $priceSlider.slider("option", "min");
                var priceMax=  $priceSlider.slider("option", "max");
                var priceMinFormatted = priceRangeValues[priceMin].toLocaleString();
                var priceMaxFormatted = priceRangeValues[priceMax].toLocaleString();

                $priceValues.find('#price-range-min').val(priceMinFormatted);
                $priceValues.find('#price-range-max').val(priceMaxFormatted);

                // Add Slider Labels
                rangeSliderLabels($priceSlider, priceRangeValues);
            },
            // On Change
            slide: function( event, ui ) {
                var priceMin =  priceRangeValues[ui.values[0]];
                var priceMax=  priceRangeValues[ui.values[1]];
                var priceMinFormatted = priceRangeValues[ui.values[0]].toLocaleString();
                var priceMaxFormatted = priceRangeValues[ui.values[1]].toLocaleString();
                $priceValues.find('#price-range-min').val(priceMinFormatted);
                $priceValues.find('#price-range-max').val(priceMaxFormatted);

                // Hide all with no values
                $aptListContainer.find('.development-grid-item[data-price=""]').each(function(){
                    $(this).addClass('is-hidden').hide();
                });
                // Check if in price range
                $aptListContainer.find('.development-grid-item[data-price!=""]').each(function(){
                    var apartmentPrice = $(this).data('price');

                    if (apartmentPrice < priceMin || apartmentPrice > priceMax) {
                        $(this).addClass('is-hidden').hide();
                    } else {
                        $(this).removeClass('is-hidden').show();
                    }
                });
            }
        });
    }

    
});